'use client';

import { useEffect } from 'react';

import i18n from '@/i18n/config';

export function I18nInit() {
  useEffect(() => {
    i18n.init((detectedLang, platformLang) => {
      console.info('detectedLang', detectedLang);
      console.info('platformLang', platformLang);
    });
  }, []);

  return null;
}
